<template>
    <el-row class="auth-footer-modal">
        <div style="text-align: left;">
            © {{ (new Date()).getFullYear() }} {{ $config.group_name }}. All rights reserved.
        </div>
        <div style="display: flex; justify-content: end;">
            <span class="footer-link">
                <a :href="$config.company_url + '/impressum'" target="_blank">{{ $trans('messages.imprint') }}</a>
            </span>
            <span class="footer-link">
                <a :href="$config.company_url + '/datenschutz'" target="_blank">{{ $trans('messages.privacy_policy') }}</a>
            </span>
            <span class="footer-link">
                <a :href="$config.company_url + '/team-deutsche-interim-ag'" target="_blank">{{ $trans('messages.about_us') }}</a>
            </span>
        </div>
    </el-row>
</template>

<script>
export default {}
</script>

<style scoped>
.auth-footer-modal {
    border-top: 10px solid #AA916A;
    padding: 12px;
    background-color: white;
    font: normal normal 400 14px/17px Barlow;
    color: #3C3C3C;
    display: flex;
    justify-content: center;
    gap: 10px;
}

.footer-link {
    margin-left: 15px;
}

.footer-link a,
.footer-link a:hover,
.footer-link a:visited {
    color: rgb(60, 60, 60);
    text-decoration: none;
}
</style>
